export default "__VITE_ASSET__y6CVIACR__"